var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { TabsNavItemCore } from '@core-front/tabs';
import Anchor from '@telia-front/anchor';
import { Badge } from '@telia-front/badge';
import Icon from '@telia-front/icon';
import Image from '@telia-front/image';
const TabsNavItem = (_a) => {
    var { icon, image, tagContent, type, text, className, current } = _a, rest = __rest(_a, ["icon", "image", "tagContent", "type", "text", "className", "current"]);
    const BEM = () => {
        const classArray = [];
        if (icon) {
            classArray.push('tabs__nav-item--icon');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const getType = () => {
        if (type === 'employee') {
            return current ? 'employee-active' : 'employee';
        }
        return current ? 'primary' : 'inactive';
    };
    return (React.createElement(TabsNavItemCore, Object.assign({}, rest, { text: text, icon: image || icon, type: type === 'employee' ? type : undefined, current: current, className: BEM(), components: {
            Anchor,
            Icon,
            Image,
        } }),
        React.createElement("div", { className: "tabs__nav-item-content" },
            React.createElement("div", { className: "tabs__nav-link-inner" }, text),
            tagContent && (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "sr-only" }, "("),
                React.createElement(Badge, { size: "medium", text: tagContent, purpose: getType(), className: "tabs__nav-item-tag" }),
                React.createElement("span", { className: "sr-only" }, ")"))))));
};
export { TabsNavItem as default };
